module.exports = __webpack_public_path__ + "static/40-9b7328ed9ba305b1d9a0b6c46ccb838a.jpg";